import React from 'react'
import ProfilerItem, { ProfilerData } from './ProfilerItem'

interface ProfilerAppProps {
	data: Record<string, ProfilerData>
}

const ProfilerApp: React.FC<ProfilerAppProps> = ({ data }) => {
	const rootSections = Object.values(data)
	const totalAppTime = rootSections.reduce((acc, section) => acc + section.totalTime, 0)

	return (
		<div className="profiler-container" style={{ fontFamily: 'monospace', fontSize: '12px', minWidth: '400px' }}>
			<h3 style={{ margin: '0 0 10px 0', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>
				Application Profiler
			</h3>
			{rootSections.length === 0 ? (
				<div>No profiling data available.</div>
			) : (
				rootSections.map((rootSection) => (
					<ProfilerItem key={rootSection.name} data={rootSection} parentTotalTime={totalAppTime} isRoot={true} />
				))
			)}
		</div>
	)
}

export default ProfilerApp
